import { css } from '@emotion/react'

export const center = css`
  text-align: center;
`

export const left = css`
  text-align: left;
`

export const right = css`
  text-align: right;
`

export const justify = css`
  text-align: justify;
`
